module.exports = __webpack_public_path__ + "static/media/7.0442ec53.png";